module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/stoichiometry/Activity4_c/spectra.json";';

}
return __p
}